<template>
  <div :class="shown ? 'total-trash-container pt-4 show' : 'total-trash-container pt-4'">
    <h2 class="text-white text-center mb-5">{{ $t('totals_main_text') }}</h2>
    <div class="container-fluid">
      <div v-for="(valueSet, index) in totalValues" class="row text-center text-white trash-item-row"
        :key="sessionNumber + '-' + index">
        <div class="col">
          <div class="ico-ct">
            <img :src="depositTypeImage(valueSet.type, true)" alt="">
          </div>
          <span class="trash-name">{{ $t('totals_' + valueSet.type + 's') }}</span>
          <div class="amount">{{ valueSet.amount }} <small>{{ $t('totals_pieces') }}</small></div>
          <div class="sum">{{ valueSet.points }} <small>{{ $t('totals_sum_points') }}</small></div>
        </div>
      </div>

      <div class="total-row row px-4">
        <div class="col text-center text-white">
          <div clss="d-block"><small>{{ $t('totals_sum_total') }}</small> <span>{{ totalPoints }}</span>
            <small>{{ $t('totals_sum_points') }}</small></div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapGetters } from 'vuex'

export default {
  components: {
  },
  props: [
    "shown", "totalValues", "totalPoints", "sessionNumber"
  ],
  computed: {
    ...mapGetters('DepositTypes', ['depositTypeImage']),
  },
  watch: {
    shown: function (value, oldValue) {
      if (value) {
        let that = this;
        setTimeout(function () {
          that.$emit('finishSession');
        }, 4000);
      }
    }
  }
}
</script>